import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["provider"];
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import getProvider from './providers';
import { withTitle } from '../../HOC';
import { VideoContextProvider } from './VideoContext';
import emitGtmEvent from './helpers/emit-gtm-event';
const VideoRender = _ref => {
  let {
      provider
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const ref = useRef(0);
  const Provider = getProvider(provider);
  const {
    gtmEventName: propEventName
  } = props;
  const gtmEventName = propEventName || process.env.BLAZE_VIDEO_EVENT_NAME;
  const emitEvent = gtmEventName ? ({
    action,
    videoId
  }) => emitGtmEvent({
    gtmEventName,
    provider,
    action,
    videoId,
    playCounter: ref
  }) : null;
  return /*#__PURE__*/React.createElement(VideoContextProvider, {
    value: {
      emitEvent
    }
  }, /*#__PURE__*/React.createElement(Provider, props));
};
VideoRender.propTypes = {
  provider: PropTypes.string.isRequired,
  gtmEventName: PropTypes.string
};
VideoRender.defaultProps = {
  gtmEventName: ''
};
export default withTitle(VideoRender);
//# sourceMappingURL=VideoRender.js.map